import { apiInstance } from "services/api.service";

export const updateCRM = async (payload) => {
  return apiInstance.put(`/api/survey/crm`, payload);
};

const baseSurveyRoute = "/api/questioner-survey";

export const getActiveQuestioner = async () => {
  return apiInstance.get(`${baseSurveyRoute}/active`);
};

export const getUserSurveyStatus = async () => {
  return apiInstance.get(`${baseSurveyRoute}/survey-status`);
};

export const saveUserSurvey = ({ id, data }) => {
  return apiInstance.post(`${baseSurveyRoute}/save/${id}`, data);
};

const storageRoute = "/api/storage";

export const getUploadMediaUrl = async (payload) => {
  return apiInstance.post(`${storageRoute}`, payload);
};

const userConfirmationSettingsRoute = `/api/confirmation-settings`;

export const getUserConfirmationSettings = async () => {
  return apiInstance.get(`${userConfirmationSettingsRoute}`);
};

// Guest Questionnaire APIs <- Publicly Accessible

export const getActiveUserTypeQuestioner = async (userType) => {
  return apiInstance.get(`${baseSurveyRoute}/active-questioner/${userType}`);
};

export const createGuestUser = async (payload) => {
  return apiInstance.post(`${baseSurveyRoute}/save-guest-user`, payload);
};

export const saveGuestUserSurvey = async ({ id, data }) => {
  return apiInstance.post(`${baseSurveyRoute}/save-guest-response/${id}`, data);
};

export const getGuestConfirmationSettings = async (userType) => {
  return apiInstance.get(
    `${baseSurveyRoute}/guest-confirmation-settings/${userType}`
  );
};
